export const tableTypePublishQA = (
  <>
    Q&A<br />
    Table Type has been unpublished.<br />
    No actions available
  </>
);
export const tableTypePublishDoc = (
  <>
    Documents<br />
    Table Type has been unpublished.<br />
    No actions available
  </>
);
export const tableTypePublishRel = (
  <>
    Relationships<br />
    Table Type has been unpublished.<br />
    No actions available
  </>
);
export const tableTypePublishhKPI = (
  <>
    KPIs/Metrics<br />
    Table Type has been unpublished.<br />
    No actions available
  </>
);
export const tableTypePublishNotes = (
  <>
    Notes<br />
    Table Type has been unpublished.<br />
    No actions available
  </>
);
export const tableTypePublishCopy = (
  <>
    Copy <br />
    Table Type has been unpublished.<br />
    No actions available
  </>
);
export const tableTypePublishLike = (
  <>
    Like <br />
    Table Type has been unpublished.<br />
    No actions available
  </>
);
export const tableTypePublishDisLike = (
  <>
    Dislike <br />
    Table Type has been unpublished.<br />
    No actions available
  </>
);
export const tableTypePublishTPPT = (
  <>
    Transfer to PPT <br />
    Table Type has been unpublished.<br />
    No actions available
  </>
);
export const tableTypePublishThresholds = (
  <>
    Thresholds <br />
    Table Type has been unpublished.<br />
    No actions available
  </>
);
export const tableTypePublishSourceLines = (
  <>
    Source Lines <br />
    Table Type has been unpublished.<br />
    No actions available
  </>
);

